export const PORTAL_URL =
  import.meta.env.VITE_PORTAL_URL ?? 'https://portal.jamejam.ai';

export const CONTACT_EMAIL =
  import.meta.env.VITE_CONTACT_EMAIL ?? 'hello@jamejam.ai';
